import { render, staticRenderFns } from "./RecommendB.vue?vue&type=template&id=42ce0bce&scoped=true&"
import script from "./RecommendB.vue?vue&type=script&lang=js&"
export * from "./RecommendB.vue?vue&type=script&lang=js&"
import style0 from "./RecommendB.vue?vue&type=style&index=0&id=42ce0bce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ce0bce",
  null
  
)

export default component.exports